import { ModalDialogue } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/modal.js'
import { getCurrentCulture } from '../utilities/Localization'
import { injectSalesHorizonForm } from './SalesHorizonForm'

export function setupBookingBarSubmit () {
  document.addEventListener('ExportBookingBarData', (e) => {
    const formData = e.detail.formData
    if (formData) {
      console.log(formData)
      setFormDefaults(formData)
      submitBookingBarForm(formData)
    }
  })
}

export function processBookingFormFromQuery () {
  const urlParams = new URLSearchParams(window.location.search)

  if (urlParams.get('shForm') !== 'true') return

  const possibleFields = [
    'oneWay', // Boolean
    'embark', // String
    'disembark', // String
    'outboundDate', // String (ISO date)
    'returnDate', // String (ISO date)
    'outboundPax', // String or number
    'returnPax', // String or number
    'paxQtyDiff' // Boolean
  ]

  const formData = {}

  possibleFields.forEach(key => {
    if (urlParams.has(key)) {
      let val = urlParams.get(key)

      if (val === 'true') {
        val = true
      } else if (val === 'false') {
        val = false
      }

      formData[key] = val
    }
  })

  submitBookingBarForm(formData)
}

function submitBookingBarForm (formData) {
  fetch('/api2/booking-bar/submit', {
    method: 'POST',
    cache: 'no-cache',
    redirect: 'follow',
    body: JSON.stringify(formData),
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': getCurrentCulture()
    }
  })
    .then((res) => {
      if (res.redirected) {
        window.location.href = res.url
        return
      }
      return res.text()
    })
    .then(html => injectNoDatesModal(html, formData))
    .catch((error) => {
      console.log('An unexpected error occurred whilst submitting the booking bar form.')
      console.log(error)
    })
}

function setFormDefaults (formData) {
  if (!formData.outboundDate) {
    const outboundDate = new Date()
    outboundDate.setDate(new Date().getDate())
    formData.outboundDate = outboundDate
  }

  // Satisfies model binder
  if (formData.returnDate === '') {
    formData.returnDate = null
  }
}

function injectNoDatesModal (html, formData) {
  if (!html) {
    return
  }

  // Check if existing and if so, wipe
  let modalWrap = document.getElementById('salesHorizonModalWrap')

  if (modalWrap) {
    modalWrap.remove()
  }

  modalWrap = document.createElement('div')
  modalWrap.id = 'salesHorizonModalWrap'
  modalWrap.innerHTML = html

  const body = document.querySelector('body')
  body.appendChild(modalWrap)

  if (modalWrap) {
    const modalElem = document.getElementById('salesHorizonNoDates')
    const modalInstance = new ModalDialogue(modalElem)
    modalInstance.open()
    setupSalesHorizonObserver(modalElem)

    // Bind events
    const signUpTrigger = modalElem.querySelector('[data-alert-form-open]')
    signUpTrigger.addEventListener('click', (e) => {
      e.stopPropagation()
      injectSalesHorizonForm(formData, '[data-sales-horizon]', modalInstance)
    })
  }
}

function setupSalesHorizonObserver (modal) {
  const config = { childList: true, subtree: true }
  const callback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const newClosers = document.querySelectorAll('[data-modal-close="salesHorizonNoDates"]:not([data-clickbound])')
        newClosers.forEach((closer) => {
          closer.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()
            modal.classList.remove('is-open')
            modal.setAttribute('aria-hidden', 'true')
            modal.close()
            modal.isOpen = false
          })
          closer.dataset.clickbound = 'true'
        })
      }
    }
  }
  const observer = new MutationObserver(callback)
  observer.observe(modal, config)
}
